@use "variables" as *;

.item {
  display: flex;
}

.skeleton {
  width: 100%;
  height: 124px !important;
  border-radius: 8px;
  min-width: 164px;
}

.noItemsText {
  margin: $spacing-xxl $spacing-m $spacing-m $spacing-m;
  width: 100%;
  font-size: $fontSize-s;
  text-align: center;
}
